import * as React from 'react';
import styled from 'styled-components';
import { SemanticUI } from '@iterable/deprecated_react_components';
import { BaseCell } from './BaseCell';

export { StatusCellOptions } from './StatusCellOptions';

const StyledIcon = styled(SemanticUI.Icon)`
  color: ${(props) => props.iconcolor};
  vertical-align: middle;
  padding-right: 10px;
`;

const BaseCellOneLine = styled(BaseCell)`
  white-space: nowrap;
`;

// type StatusCellProps = {
//   text: string,
//   color: string,
// };

export const StatusCell = ({ text, color }) => (
  <BaseCellOneLine data-test="status-cell-base-cell">
    <StyledIcon name="circle" size="mini" iconcolor={color} />
    {text}
  </BaseCellOneLine>
);

export const CleanStatusCell = ({ text, color }) => (
  <React.Fragment>
    <StyledIcon name="circle" size="mini" iconcolor={color} />
    {text}
  </React.Fragment>
);
